import * as styles from './index.module.scss';
import { observer } from 'mobx-react';
import { Flex } from 'antd';
import IconButton from '../../../ui/IconButton';
import Kanban from '../Kanban';
import { useParams } from 'react-router-dom';
import OrderFormModal from '../OrderFormModal';
import { useState } from 'react';

const MainPage = () => {
  const { id: workspaceId } = useParams();
  const [modalOpen, setModalOpen] = useState(false);

  return (
    <Flex vertical gap={16}>
      <Flex align="center" gap={16}>
        <div className={styles.titleBlock}>Центр доставки</div>

        <IconButton
          className={styles.addButton}
          icon="fi-rr-plus"
          variant="clear"
          onClick={() => setModalOpen(true)}
        />
      </Flex>

      {workspaceId && <Kanban workspaceId={workspaceId} />}

      <OrderFormModal open={modalOpen} onCancel={() => setModalOpen(false)} />
    </Flex>
  );
};

export default observer(MainPage);
